import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';
import { CompanyGuard } from 'src/auth/guard/company-guard';
import { EmployeeGuard } from 'src/auth/guard/employee-guard';

// ----------------------------------------------------------------------

const JobsPage = lazy(() => import('src/pages/jobs'));
const JobDetailsPage = lazy(() => import('src/pages/jobs/details'))

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const jobsRoutes = [
  {
    path: '/jobs',
    element: CONFIG.auth.skip
      ? <>{layoutContent}</>
      : <AuthGuard>
        <CompanyGuard>
          <EmployeeGuard roles={["Regulator"]}>
            {layoutContent}
          </EmployeeGuard>
        </CompanyGuard>
      </AuthGuard>,
    children: [
      { element: <JobsPage />, index: true },
      { path: ':id/details', element: <JobDetailsPage /> }
    ],
  },
];
